import { render } from "./SliderNr1.vue?vue&type=template&id=8e6d861a&scoped=true"
import script from "./SliderNr1.vue?vue&type=script&lang=js"
export * from "./SliderNr1.vue?vue&type=script&lang=js"

import "./SliderNr1.vue?vue&type=style&index=0&id=8e6d861a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e6d861a"]])

export default __exports__